<template>
  <div>
    <b-button variant="primary" @click="openDefaultDaysModal" class="mt-2">
      {{ $t('set_invoice_auto_remove_days') }}
    </b-button>

    <b-modal
        v-model="showDefaultDaysModal"
        :title="$t('set_invoice_auto_remove_days')"
        :ok-title="$t('save')"
        :cancel-title="$t('cancel')"
        @ok.prevent="handleSave"
    >
      <b-form-group :label="getTitle(type)">
        <b-form-input
            v-model.number="default_inactive_days"
            :placeholder="$t('set_invoice_auto_remove_days_placeholder')"
            type="number"
            min="1"
            max="999"
            @input="validateDefaultDays"
        ></b-form-input>
        <div class="mt-1 text-danger" v-if="this.daysError">
          {{ $t(this.daysError) }}
        </div>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  name: "SetAutoRemoveDaysModal",
  props: {
    type: {
      type: String,
      required: true
    },
    inputInitialValue: {
      type: [Number, null],
      default: null
    },
  },

  data(){
    return {
      showDefaultDaysModal: false,
      default_inactive_days: null,
      daysError: "",
      titles: {
        "change-default-time": "set_invoice_auto_remove_days_desc",
        "change-current-invoice-time": "set_invoice_auto_remove_days_desc_invoice_level"
      }
    }
  },

  methods:{
    getTitle(type) {
      return this.$t(this.titles[type] || '');
    },

    handleSave() {
      if (!this.validateDefaultDays()) return;
      if (this.type === 'change-current-invoice-time'){
        this.$emit('get-auto-remove-time', this.default_inactive_days);
        this.showDefaultDaysModal = false;
        return;
      }

      this.$http.post('/user/save-remove-days', {
        days: this.default_inactive_days,
        type: this.type
      }).then(() => {
        this.showDefaultDaysModal = false;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("success"),
            icon: "SuccessIcon",
            variant: "success",
          },
        });
      });
    },

    validateDefaultDays() {
      const val = this.default_inactive_days;
      if (!Number.isInteger(val) || val < 1 || val > 999) {
        this.daysError = "set_invoice_auto_remove_days_error";
        return false;
      } else {
        this.daysError = "";
        return true;
      }
    },

    openDefaultDaysModal() {
      if(this.inputInitialValue !== null) {
        this.default_inactive_days = this.default_inactive_days ?? this.inputInitialValue;
        this.showDefaultDaysModal = true;
        return;
      }
      this.$http.post('/user/get-remove-days').then((res) => {
        if (res && res.data) {
          this.default_inactive_days = res.data.value.auto_remove_days;
        }
        this.showDefaultDaysModal = true;
      }).catch(() => {
        this.showDefaultDaysModal = true;
      });
    },
  }
}
</script>

<style scoped>

</style>